import { LEADERBOARD_POINTS_CONFIG } from "@/src/constants/leaderboard.constant";
import { useAuth } from "@/src/contexts/auth.context";
import { LeaderboardEntry } from "@/src/models/leaderboard.model";
import {
    LEADERBOARD_QUERY_KEYS,
    useUpsertLeaderboardPoints,
} from "@/src/services/api/leaderboard/leaderboard.hooks";
import { useQueryClient } from "@tanstack/react-query";

export const useShareWithPoints = () => {
  const { user } = useAuth();
  const userId = user?.itemId ?? "";

  const queryClient = useQueryClient();
  const upsertPoints = useUpsertLeaderboardPoints();

  const handleSharedSuccessfully = () => {
    if (!userId) return;

    const delta = LEADERBOARD_POINTS_CONFIG["share"];
    if (!delta) return;

    const currentEntry =
      queryClient.getQueryData<LeaderboardEntry | null>(
        LEADERBOARD_QUERY_KEYS.byUser(userId),
      ) ?? null;

    upsertPoints.mutate({ userId, pointsDelta: delta, currentEntry });
  };

  return { handleSharedSuccessfully };
};
